export function loadProgressDelta(
  raw: number,
  block: number,
  negotiate: boolean,
): number {
  if (raw >= 0 || !negotiate || block <= 0) return raw;
  return Math.min(0, raw + block);
}
